import {useState} from 'react'
import {PageHeader, SectionTitle} from '@/components/molecules'
import {DynamicColumnTable, PageContainer} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {useProductList} from '@/hooks/useProductList'
import {LinkText} from '@/components/atoms'
import {ProductButtonContainer} from '@/containers/ProductButtonContainer'
import {FONT_SIZE} from '@/utils/constants/globalStyle'

import '@/assets/scss/custom/components/_productList.scss'

const cellDataMapperObj = {
  productId: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText text={original?.productId} id={original?.productId + ' ' + original?.id} handleClick={() => {}} />
      </div>
    )
  },
  productName: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText text={original?.productName} id={original?.productName + ' ' + original?.id} handleClick={() => {}} />
      </div>
    )
  },
}

export const ProductList = () => {
  const [rowSelected, setRowSelected] = useState([])
  const {productListData, productListColConfigData} = useProductList()

  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, productListColConfigData)

  return (
    <div className="ProductListContainer">
      <PageHeader title="Products" fontSize={FONT_SIZE.XXXL} />
      <ProductButtonContainer />
      <PageContainer data-testid="create-bulk-point-modifiers-content">
        <div>
          <SectionTitle label={'Products list'} />
        </div>

        <div className="ProductListDataTable">
          {productListColConfigData?.length > 0 && productListData?.items && (
            <DynamicColumnTable
              columns={cellDataMappedCols || []}
              records={productListData?.items || []}
              rowSelection={rowSelected}
              setRowSelection={setRowSelected}
              toolbarActions={[
                {
                  text: 'Download',
                  variant: 'secondary',
                  onClick: () => {
                    // click
                  },
                },
              ]}
            />
          )}
          {productListData?.total_records && (
            <div className="txtRightAlign">{productListData?.total_records} total items</div>
          )}
        </div>
      </PageContainer>
    </div>
  )
}
